import * as React from 'react';
import { IArticleListItem } from '../shared/shared-types';

export interface ISearchArticleListItemProps {
    item: IArticleListItem,
    searchString: string,
    onClickHandler(hitId: string): void
}

export class SearchArticleListItem extends React.Component<ISearchArticleListItemProps, {}>{

    get hitId(): string {
        return this.props.item.hitId;
    }

    get title(): { __html: string } {
        const title = this.props.item.title;
        return {
            __html: this.replace(title)
        };
    }

    get teaser(): { __html: string } {
        const teaser = this.props.item.teaser;
        return {
            __html: this.replace(teaser)
        };
    }

    private replace(text: string): string {
        if (text) {
            const searchStr = this.props.searchString.replace(/[.*+?|()\[\]{}\\$^]/g, '\\$&');
            const regex = new RegExp(`(${searchStr})`, 'gi');
            return text.replace(regex, '<strong>$1</strong>');
        } else return '';
    }

    render() {
        return (
            <a className={'article-list-item search-listing-item' + (this.props.item.isFtp ? ' isFtp' : '')} href={this.props.item.url}
                onClick={() => this.props.onClickHandler(this.hitId)}>
                <div className="search-listing-item-row search-listing-item-tag-container">
                    
                    <h6 className={'search-listing-item-tag ' + this.props.item.categoryTheme}>{this.props.item.category}
                        <span className={'search-listing-item-tag ' + this.props.item.subCategory1Theme}> {this.props.item.subCategory1}</span>
                        <span className={'search-listing-item-tag ' + this.props.item.subCategory2Theme}> {this.props.item.subCategory2}</span>
                        <span className={'search-listing-item-tag ' + this.props.item.subCategory3Theme}> {this.props.item.subCategory3}</span>
                    </h6>
                    <small className="article-list-item-type">{this.props.item.mediaType}</small>
                </div>
                <div className="search-listing-item-row search-listing-item-text-container">
                    <div className="search-listing-item-text">
                        <h3 className="article-list-item-title" dangerouslySetInnerHTML={this.title}></h3>
                        <p className="search-listing-item-preview" dangerouslySetInnerHTML={this.teaser}></p>
                    </div>
                    {this.props.item.thumbnail &&
                        <img className="search-listing-item-img" src={this.props.item.thumbnail}/>
                    }
                </div>
            </a>
        );
    }
}




// WEBPACK FOOTER //
// ./~/source-map-loader!./app/src/slp/search-article-list-item.tsx